var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box pl-5" },
      [
        _c(
          "div",
          {
            staticClass:
              "is-flex is-flex-direction-row is-justify-content-space-between",
          },
          [
            _c("h1", { staticClass: "subtitle is-5" }, [
              _vm._v("Datos de la solicitud"),
            ]),
            _vm._v(" "),
            _c(
              "b-tooltip",
              { attrs: { label: "Fecha de solicitud" } },
              [
                _c(
                  "b-field",
                  [
                    _c(
                      "b-tag",
                      {
                        attrs: {
                          size: "is-medium",
                          type: "is-warning is-light",
                          icon: "fas fa-calendar",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(this.dateFormat(this.requestInformation.date))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            "Verifique los datos de la solicitud y la información actual del empleado."
          ),
        ]),
        _vm._v(" "),
        _c(
          "b-table",
          { attrs: { data: _vm.tableInfo, loading: _vm.isLoading } },
          [
            _c("b-table-column", {
              attrs: { field: "field", label: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("span", { staticClass: "has-text-weight-semibold" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(props.row.field) +
                            "\n          "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("b-table-column", {
              staticClass: "has-text-weight-bold",
              attrs: {
                field: "request_info",
                centered: "",
                label: "Datos solicitud",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.row.request_info) +
                          "\n      "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("b-table-column", {
              attrs: {
                field: "actual_info",
                centered: "",
                label: "Datos empleado",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.row.actual_info) +
                          "\n      "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("b-table-column", {
              attrs: { field: "is_equal", label: "Coincidencia", centered: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c(
                        "span",
                        [
                          _c("b-icon", {
                            attrs: {
                              pack: "fas",
                              icon: props.row.is_equal ? "check" : "times",
                              type: props.row.is_equal
                                ? "is-success"
                                : "is-danger",
                              size: "is-medium",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-notification",
          {
            attrs: {
              type: "is-primary is-light mt-5",
              "has-icon": "",
              closable: false,
            },
          },
          [
            _c("i", { staticClass: "fas fa-info-circle fa-lg mr-4" }),
            _vm._v(
              "\n      Al continuar, confirma que los datos son correctos y el solicitante "
            ),
            _c("b", [_vm._v("firmó")]),
            _vm._v(" el acuerdo de suscriptores.\n    "),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons is-right mt-6" },
          [
            _c(
              "b-button",
              { staticClass: "is-light mr-2", on: { click: _vm.goBack } },
              [_vm._v("\n        Volver\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              { staticClass: "is-primary", on: { click: _vm.approveCert } },
              [_vm._v("\n        Continuar\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-4" }, [_vm._v("Certificados")]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-3" }, [_vm._v("Aprobar certificado")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }